import { WEBVIEW_TYPES } from '@/lib/consts.js'
import AndroidIdentity from './android-identity.js'
import IOSIdentity from './ios-identity.js'

export const TOKEN_ACTIONS = {
  REGISTER: 'registerToken',
  CLEAR: 'clearToken',
}

export const DEVICE_CLASSES = {
  [WEBVIEW_TYPES.ANDROID]: AndroidIdentity,
  [WEBVIEW_TYPES.IOS]: IOSIdentity,
}
